/** Firebase can dispatch an older null callback after persistence has installed a user. */
export function confirmedSignedOut(eventUser: unknown, currentUser: unknown): boolean {
  return eventUser === null && currentUser === null;
}
